import React, { Component } from 'react'
import { Button, Col, DatePicker, Form, Icon, Input, Row } from 'antd'
import InputNumber from 'rc-input-number'
import moment from 'moment'
import _ from 'lodash'

import 'antd/lib/input-number/style/css'
import './TermsAndConditionsForm.scss'

const FormItem = Form.Item

export class TermsAndConditionsForm extends Component {
    renderQuotationInfo() {
        const { status, type, onFieldChange, onFieldDateChange, onFieldValueChange, isDocumentSent, termsAndConditions } = this.props

        if (type === 'quotation') {
            const { commencement_date, working_period, working_period_remark } = termsAndConditions
            const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent || type === 'variation-order'
            
            return [
                (
                    <li key="commencement-date">
                        <h5>Commencement Date</h5>
                        {
                            isLocked ? (commencement_date ? moment(commencement_date).format('YYYY-MM-DD') : 'TBC') :
                            <DatePicker
                                value={commencement_date ? moment(commencement_date) : undefined}
                                allowClear
                                min={0}
                                placeholder="TBC"
                                onChange={onFieldDateChange.bind(this, 'commencement_date')}
                            />
                        }
                    </li>
                ), (
                    <li key="working-period">
                        <h5>Working Period</h5>
                        {
                            isLocked ? (working_period ? `${working_period} Days` : 'TBC') :
                            <InputNumber
                                value={working_period}
                                prefixCls="ant-input-number"
                                min={0}
                                formatter={value => value ? `${value} Working Days` : ''} 
                                parser={string => string.replace(/[^\d]/g, '')} 
                                placeholder="TBC"
                                onChange={onFieldValueChange.bind(this, 'working_period')}
                            />
                        }
                        {
                            isLocked ? working_period_remark :
                            <Input
                                value={working_period_remark}
                                placeholder="Input remark if any"
                                onChange={onFieldChange.bind(this, 'working_period_remark')}
                            />

                        }
                    </li>
                )
            ]
        }
    }

    renderPaymentRow() {
        const {
            status,
            type,
            isDocumentSent,
            termsAndConditions,
            onPaymentNumberChange,
            onPaymentChange,
            onPaymentDateChange,
            onPaymentRemove
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent
        const isTemplate = type === 'template'

        return _.map(termsAndConditions.payments, (payment, paymentIdx) => {
            const { name, percentage, amount, description, due } = payment

            return (
                <Row gutter={8} key={`payment-${paymentIdx}`}>
                    <Col span={4}>
                        <FormItem>
                        {   
                            isLocked ? name :
                            <Input 
                                size="default"
                                placeholder="Input payment name"
                                value={name} 
                                onChange={onPaymentChange.bind(this, paymentIdx, 'name')}
                            />
                        }
                        </FormItem>
                    </Col>
                    <Col span={2}>
                        <FormItem>
                        {   
                            isLocked ? `${percentage} %` :
                            <InputNumber 
                                prefixCls="ant-input-number"
                                min={0}
                                max={100}
                                formatter={value => `${value}%`}
                                parser={value => value.replace('%', '')}
                                value={percentage}
                                onChange={onPaymentNumberChange.bind(this, paymentIdx, 'percentage')}
                            />
                        }
                        </FormItem>
                    </Col>
                    <Col span={2}>
                        <FormItem>
                        {   
                            isLocked ? `$ ${amount}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') :
                            <InputNumber 
                                prefixCls="ant-input-number"
                                min={0}
                                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                value={amount}
                                onChange={onPaymentNumberChange.bind(this, paymentIdx, 'amount')}
                            />
                        }
                        </FormItem>
                    </Col>
                    <Col span={isTemplate ? 15 : 12}>
                        <FormItem>
                        {   
                            isLocked ? description :
                            <Input 
                                size="default"
                                placeholder="Input additional description if any" 
                                value={description} 
                                onChange={onPaymentChange.bind(this, paymentIdx, 'description')}
                            />
                        }
                        </FormItem>
                    </Col>
                    {
                        !isTemplate &&
                        <Col span={3}>
                            <FormItem 
                                labelCol={{ span: 6 }}
                                wrapperCol={{ span: 18 }}
                                label="Due"
                            >
                            {   
                                isLocked ? (due ? moment(due).format('YYYY-MM-DD') : 'N/A') :
                                <DatePicker 
                                    size="default"
                                    allowClear
                                    placeholder="TBC"
                                    value={due ? moment(due) : undefined}
                                    onChange={onPaymentDateChange.bind(this, paymentIdx, 'due')}
                                />
                            }
                            </FormItem>
                        </Col>
                    }
                    {
                        (!isLocked) && (
                            <Col span={1}>
                                <div className="rm-payment-btn" onClick={onPaymentRemove.bind(this, paymentIdx)}>
                                    <Icon type="close" />
                                </div>
                            </Col>
                        )
                    }
                </Row>
            )
        })
    }

    renderPaymentSection() {
        const { status, onPaymentAdd, isDocumentSent, type } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent

        if (type === 'quotation' || type === 'sub-quotation' || type === 'template')
            return (
                <li>
                    <h5>Payment Terms</h5>
                    <div className="payment-terms">
                        {this.renderPaymentRow()}
                        { !isLocked && (<Button className="add-payment-btn" type="default" onClick={onPaymentAdd.bind(this)}>Add Payment</Button>) }
                    </div>
                </li>
            )
    }

    renderOtherSection() {
        const {
            status,
            isDocumentSent,
            termsAndConditions,
            onSectionChange,
            onSectionRemove
        } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent 

        return _.map(termsAndConditions.sections, (section, sectionIdx) => {
            return (
                <li key={`section-${sectionIdx}`} className="section">
                    <div className="section-header">
                        { isLocked ? section.title :
                            <Input
                                placeholder={'Input section name'}
                                value={section.title}
                                onChange={onSectionChange.bind(this, sectionIdx, 'title')}
                            />
                        }
                        {
                            !isLocked && (
                                <div className="rm-section-btn" onClick={onSectionRemove.bind(this, sectionIdx)}>
                                    <Icon type="close" />
                                </div>
                            )
                        }
                    </div>
                    { isLocked ? <div className="section-description">{section.description}</div> :
                        <Input
                            placeholder={'Input section description if any'}
                            type="textarea" 
                            value={section.description}
                            onChange={onSectionChange.bind(this, sectionIdx, 'description')}
                        />
                    }
                </li>
            )
        })
    }

    render() {
        const { status, onSectionAdd, isDocumentSent } = this.props
        const isLocked = status === 'completed' || status === 'inactive' || isDocumentSent

        return (
            <Form className="TermsAndConditionsForm">
                <ol>
                    {this.renderQuotationInfo()}
                    {this.renderPaymentSection()}
                    {this.renderOtherSection()}
                </ol>
                { !isLocked && (<Button className="add-section-btn" type="primary" size="large" onClick={onSectionAdd.bind(this)}>Add Section</Button>) }
            </Form>
        )
    }
}

export default TermsAndConditionsForm



// WEBPACK FOOTER //
// ./src/Commons/TermsAndConditionsForm/TermsAndConditionsForm.js